import { jsx as _jsx } from "react/jsx-runtime";
import { useResolvedUrl, parseUrlScheme, mapSchemeToRoute } from './useResolvedUrl';
import { CodeBlockPlaceholder } from './CodeBlockPlaceholder';
/**
 * Markdown link component with support for custom URL schemes.
 * Handles artifact:, image:, store:, document://, and collection: URLs.
 */
export function MarkdownLink({ node, href, children, className, artifactRunId, ExistingLink, ...rest }) {
    const rawHref = href || '';
    const { scheme, path } = parseUrlScheme(rawHref);
    // For schemes that map directly to routes (store:, document://, collection:)
    const mappedRoute = mapSchemeToRoute(scheme, path);
    if (mappedRoute) {
        if (typeof ExistingLink === 'function') {
            return (_jsx(ExistingLink, { node: node, href: mappedRoute, ...rest, children: children }));
        }
        return (_jsx("a", { href: mappedRoute, ...rest, className: className, target: "_blank", rel: "noopener noreferrer", children: children }));
    }
    // For standard URLs, delegate to existing component or render directly
    if (scheme === 'standard') {
        if (typeof ExistingLink === 'function') {
            return (_jsx(ExistingLink, { node: node, href: href, ...rest, children: children }));
        }
        return (_jsx("a", { href: href, ...rest, className: className, target: "_blank", rel: "noopener noreferrer", children: children }));
    }
    // For artifact: and image: URLs, use the resolver
    return (_jsx(ResolvedLink, { rawHref: rawHref, artifactRunId: artifactRunId, className: className, rest: rest, children: children }));
}
/**
 * Internal component for links that need async URL resolution
 */
function ResolvedLink({ rawHref, artifactRunId, className, children, rest, }) {
    const { url, isLoading, error, retry } = useResolvedUrl({
        rawUrl: rawHref,
        artifactRunId,
        disposition: 'attachment',
    });
    if (isLoading) {
        return (_jsx("span", { className: "inline-flex items-center gap-1 text-muted", children: _jsx(CodeBlockPlaceholder, { type: "link" }) }));
    }
    if (error) {
        return (_jsx("span", { className: "inline-flex items-center gap-1", children: _jsx(CodeBlockPlaceholder, { type: "link", error: error, onRetry: retry }) }));
    }
    return (_jsx("a", { href: url || '#', ...rest, className: className, target: "_blank", rel: "noopener noreferrer", children: children }));
}
//# sourceMappingURL=MarkdownLink.js.map